<template>
  <div v-title data-title="填写收货地址" class="mobile">
    <div class="weui-panel weui-panel_access">
      <div class="weui-panel__hd">您的年卡套餐</div>
      <div class="weui-panel__bd" style="padding: 10px">
        <p>{{ yearCardType.Type }}-{{ yearCardType.Name }}</p>
      </div>
    </div>

    <div class="weui-cells" style="margin: 20px 0px">
      <div class="weui-cell">
        <textarea
          class="weui-textarea"
          v-model="Message"
          placeholder="请粘贴收货地址"
          rows="3"
        ></textarea>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd"></div>
        <div class="weui-cell__ft">
          <button class="auto-discern" @click="autoDiscern()">自动识别</button>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
            <wv-cell title="预约发货时间" :value="model.sendDate" @click="openPicker('datePicker1')"/>
              <wv-datetime-picker
              type="date"
              ref="datePicker1"
              :startDate="new Date()"
              year-format="{value} 年"
              month-format="{value} 月"
              date-format="{value} 日"
              @confirm="onConfirm"
      />
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <wvi-input
            placeholder="请输入姓名"
            ref="1"
            v-model="model.deliveryName"
            :validate-info="{ errormsg: '姓名不可为空' }"
            required
          ></wvi-input>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <wvi-input
            placeholder="请输入电话"
            ref="2"
            v-model="model.deliveryPhone"
            pattern="^[1][0-9]{10}$"
            maxlength="11"
            :validate-info="{ errormsg: '手机号码不合法' }"
            required
          ></wvi-input>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <wv-cell
            title="省/市/区"
            is-link
            :value="ProvinceAndCity | pickerValueFilter"
            @click.native="dayPickerShow = true"
          />
        </div>
      </div>

      <div class="weui-cell">
        <div class="weui-cell__bd">
          <wvi-textarea
            label="详细地址"
            placeholder="如道路、小区、楼栋号、单元室等"
            ref="3"
            v-model="model.deliveryAddress"
            :validate-info="{ errormsg: '详细地址不可为空' }"
            required
          ></wvi-textarea>
        </div>
      </div>
      <div class="weui-cell">
        <a href="javascript:;" class="btn-pickup" @click="save">提货</a>
      </div>
    </div>
    <wv-picker
      :visible.sync="dayPickerShow"
      :columns="dayColumns"
      v-model="ProvinceAndCity"
      @confirm="confirmDayTime"
    />
  </div>
</template>

<script>
import { Toast } from "we-vue";
import AddressParse from "address-parse";
export default {
  name: "editdeliveryInfo",
  data() {
    return {
      dayPickerShow: false,
      ProvinceAndCity: "",
      provinceWithCity: [],
      ProvinceAndCityold: ["", "", ""],
      Message: "",
      yearCardType: {
        Name: "",
      },
      model: {
        deliveryName: "",
        deliveryPhone: "",
        deliveryProvince: "",
        deliveryCity: "",
        deliveryRegion: "",
        deliveryAddress: "",
        sendDate:this.$options.filters['datetimeFilter'](new Date(),"date"),
      },
      dayColumns: [
        {
          values: [],
          defaultIndex: 0,
        },
        {
          values: [],
          defaultIndex: 0,
        },
        {
          values: [],
          defaultIndex: 0,
        },
      ],
    };
  },
  created() {
    this.yearCardType = JSON.parse(this.$route.query.YearCardType);
    this.model.yearCardGuid = this.$route.query.YearCardGuid;
    this.getProvinceWithCity();
  },
  methods: {
    getProvinceWithCity: function () {
      this.$http
        .get(
          this.GLOBAL.BASE_URL + "api/tbdeliveryaddress/getprovincewithcity",
          {
            params: {},
          }
        )
        .then(
          function (d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.provinceWithCity = rep.Data;
              var p = [];
              var c = [];
              var a = [];
              for (var i = 0; i < this.provinceWithCity.length; i++) {
                p.push(this.provinceWithCity[i].Name);
              }
              for (var i = 0; i < this.provinceWithCity[0].Childs.length; i++) {
                c.push(this.provinceWithCity[0].Childs[i].Name);
              }
              for (
                var i = 0;
                i < this.provinceWithCity[0].Childs[0].Childs.length;
                i++
              ) {
                a.push(this.provinceWithCity[0].Childs[0].Childs[i].Name);
              }
              this.dayColumns = [
                {
                  values: p,
                  defaultIndex: 0,
                },
                {
                  values: c,
                  defaultIndex: 0,
                },
                {
                  values: a,
                  defaultIndex: 0,
                },
              ];
            } else {
              Toast.fail(rep.Message);
            }
          },
          function (d) {
            console.log(d);
          }
        );
    },
    validatesave: function () {
      debugger
      var com = this.$refs;
      delete com.datePicker1;
      var flag = true;
      for (var c in com) {
        this.$refs[c].validate();
        flag = this.$refs[c].valid;

        if (!flag) return flag;
      }
      return flag;
    },
    autoDiscern: function () {
      var ssqArr = [];
      if (
        this.Message == null ||
        this.Message == "" ||
        this.Message == undefined
      ) {
        return;
      }
      var result = AddressParse.parse(this.Message);
      console.log(result);

      this.model.deliveryName = result[0].name;
      this.model.deliveryPhone = result[0].mobile;
      if (
        result[0].province == "北京" ||
        result[0].province == "天津" ||
        result[0].province == "上海" ||
        result[0].province == "重庆"
      ) {
        result[0].province += "市";
      }
      ssqArr.push(result[0].province);
      ssqArr.push(result[0].city);
      ssqArr.push(result[0].area == undefined ? "" : result[0].area);
      this.ProvinceAndCity = ssqArr;
      this.model.deliveryAddress = result[0].details;
    },
    confirmDayTime(picker) {
      this.ProvinceAndCity = picker.getValues();
      this.ProvinceAndCityold = this.ProvinceAndCity;
    },
    save() {
      if (!this.validatesave()) {
        return;
      }
      if (this.ProvinceAndCity == "" || this.ProvinceAndCity == undefined) {
        Toast.fail("请选择省市区");
        return;
      }
      this.model.deliveryProvince = this.ProvinceAndCity[0];
      this.model.deliveryCity = this.ProvinceAndCity[1];
      this.model.deliveryRegion =
        this.ProvinceAndCity[2] == undefined ? "" : this.ProvinceAndCity[2];
      let promise = this.$http.post(
        this.GLOBAL.BASE_URL + "api/yearcard/extractcrab",
        this.model,
        { emulateJSON: true }
      );
      promise.then(function (d) {
        var rep = JSON.parse(d.bodyText);
        if (rep.Success) {
          let data = rep.Data;
          if (data.state) {
            Toast.success("年卡提货成功!");
            this.$router.push({
              path: "/page/yearpurchases/pickup",
            });
          } else {
            Toast.fail(data.message);
          }
        } else {
          Toast.fail(rep.Message);
        }
      });
    },
     onConfirm(picker) {
        this.model.sendDate =  this.$options.filters['datetimeFilter'](picker,"date")
     },
     openPicker(ref) {
        this.$refs[ref].open();
        
      },
  },
  watch: {
    ProvinceAndCity(val) {
      var provincechilds = [];
      for (var i = 0; i < this.provinceWithCity.length; i++) {
        if (this.provinceWithCity[i].Name == this.ProvinceAndCity[0]) {
          provincechilds = this.provinceWithCity[i].Childs;
          break;
        }
      }
      var c = [];
      for (var i = 0; i < provincechilds.length; i++) {
        c.push(provincechilds[i].Name);
      }
      this.dayColumns[1].values = c;

      //省发生了变化
      if (this.ProvinceAndCityold[0] != this.ProvinceAndCity[0]) {
        var a = [];
        for (var i = 0; i < provincechilds[0].Childs.length; i++) {
          a.push(provincechilds[0].Childs[i].Name);
        }
        this.dayColumns[2].values = a;
        if (this.ProvinceAndCity[1] == "") {
          this.ProvinceAndCity[1] = provincechilds[0].Name; //修改默认市的名称
        }
        if (this.ProvinceAndCity[2] == "") {
          this.ProvinceAndCity[2] = provincechilds[0].Childs[0].Name;
        }
      }
      //市发生了变化
      if (this.ProvinceAndCityold[1] != this.ProvinceAndCity[1]) {
        //修改默认区的名称
        var citychilds = [];
        for (var i = 0; i < provincechilds.length; i++) {
          if (provincechilds[i].Name == this.ProvinceAndCity[1]) {
            citychilds = provincechilds[i].Childs;
            if (this.ProvinceAndCity[2] == "") {
              this.ProvinceAndCity[2] = citychilds[0].Name;
            }

            var a = [];
            for (var i = 0; i < citychilds.length; i++) {
              a.push(citychilds[i].Name);
            }
            this.dayColumns[2].values = a;
            break;
          }
        }
      }
      this.ProvinceAndCityold = this.ProvinceAndCity;
    },
  },
  filters: {
    pickerValueFilter(val) {
      if (Array.isArray(val)) {
        return val.toString();
      } else {
        return "请选择";
      }
    },
    datetimeFilter(value, type) {
            if (value !== null && typeof value === "object") {
                let year = value.getFullYear();
                let month = value.getMonth() + 1;
                let date = value.getDate();
                let hour = value.getHours();
                let minute = value.getMinutes();

                return type === "date"
                    ? `${year}-${month}-${date}`
                    : `${year}-${month}-${date} ${hour}:${minute}`;
            } else {
                return value;
            }
        }
  },
};
</script>

<style scoped>
.auto-discern {
  width: 80px;
  height: 30px;
  border-radius: 20px;
  border: none;
  background: #7cc17c;
  color: white;
}
.weui-panel__bd p {
  width: 100%;
  height: 40px;
  line-height: 40px;
  background: #d28a21;
  vertical-align: middle;
  text-align: center;
  color: white;
  border-radius: 5px;
}
.btn-pickup {
  width: 100%;
  background: #d28a21;
  position: relative;
  display: block;
  box-sizing: border-box;
  font-size: 14px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  line-height: 2.55555556;
  border-radius: 25px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  overflow: hidden;
}
.btn-pickup :active {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/yearcard/editdeliveryInfo.vue